import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { StockLevelConstants } from '../../constants/stock-level.constants';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-bom-stock-level',
    templateUrl: './bom-stock-level.component.html',
    styleUrls: ['./bom-stock-level.component.scss'],
    standalone: false
})
export class BomStockLevelComponent {
  stockLevelConstants = StockLevelConstants;

  @Input() stockLevel;
}
